module.exports = __webpack_public_path__ + "static/media/kid-decorating-cupcake.fb2233a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/2017-11-4/kid-decorating-cupcake.jpg
// module id = 804
// module chunks = 0